class ImageWithTextSlider extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      contentSlider: '#contentSwiper',
      imageSlider: '#imageSwiper',
    };
    this.init();
  }

  init() {
    this.contentSlider = this.querySelector(this.selectors.contentSlider);
    this.imageSlider = this.querySelector(this.selectors.imageSlider);

    if (this.contentSlider && this.imageSlider) {
      const contentSwiper = new Swiper(this.contentSlider, {
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        touchEventsTarget: 'container',
        simulateTouch: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
      });

      const imageSwiper = new Swiper(this.imageSlider, {
        loop: false,
        slidesPerView: 1,
        simulateTouch: true,
        touchEventsTarget: 'container',
      });

      // Sync both swipers
      contentSwiper.controller.control = imageSwiper;
      imageSwiper.controller.control = contentSwiper;
    }
  }
}

customElements.define('image-with-text-slider', ImageWithTextSlider);
